import { Api } from './axios-config';

export interface ICommissionCheckpointView {
  id: number;
  businessEmployeeId: number;
  employeeName: string;
  commissionGoalId: number;
  goalName: string;
  cycleIndex: number;
  periodStart: string;
  periodEnd: string;
  totalCommission: number;
  createdAt: string;
  isCurrentCycle: boolean;
}

const getCheckpoints = async (businessEmployeeId: number, limit = 10): Promise<ICommissionCheckpointView[]> => {
  const { data } = await Api.get(`/commissionCheckpoint/employee/${businessEmployeeId}?limit=${limit}`);
  return data;
};

export const commissionCheckpointService = {
  getCheckpoints,
};
